import { type FunctionComponent, useState } from 'react';
import { FormControlLabel, Switch } from "@mui/material";
import {
  deleteCurrentSetting,
  deliverySetting0, setDeliverySetting0,
} from "@/react/SetShippingFeesView/SetShippingFeesLogic.tsx";
import TextField from "@/react/core/TextField.tsx";
import type { DeliverySetting } from "@/data/DeliverySetting.ts";
import _ from "lodash";
import { makeRipple } from "@/react/core/ripple-utils.ts";
import { LL3 } from "@/react/core/I18nCurrency.tsx";
import {
  debounceDrawPolygon,
  DELIVERY_ZONE_COLORS,
  updateColorPolygon
} from "@/react/DeliveryManagementView/google-map-logic.ts";

export type ZoneItem = {
  setting: DeliverySetting;
};
const ZoneFormItem: FunctionComponent<ZoneItem> = ({ setting }) => {

  // const [isExpanded, setIsExpanded] = useState(false);
  const isSelected = deliverySetting0()?._id === setting._id
  return (
    <div className="w-full border border-[#a0a0a0] rounded p-1">
      {!isSelected &&
        <div
          onClick={() => {
            setDeliverySetting0(setting)
          }}
          className="flex flex-col">
          <div
            className="flex-1 flex"
          >
            <div className="flex-1 flex gap-2 items-center">
              <div className="w-4 h-4 rounded-full" style={{ backgroundColor: setting?.color }} />
              <span className="text-[14px] font-bold">{setting?.zoneName || ''}</span>
            </div>
            <img
              className="w-[24px] relative h-[24px] object-cover"
              alt=""
              src="/iconarrow-down@2x.png"
            />
          </div>
          <div className="flex flex-col flex-1 text-[12px] text-[#1e1e23]">
            <p className="font-semibold">Minimum order
              value: <span className="font-bold">{LL3().format.currency(setting.minOrderValue || 0)}</span></p>
            <p className="font-semibold">Delivery
              cost: <span className="font-bold">{LL3().format.currency(setting.cost || 0)}</span></p>
          </div>
        </div>}
      {isSelected &&
        <div className="flex flex-col">
          <div
            className="flex"
            onClick={() => setDeliverySetting0(null)}
          >
            <div className="flex-1 flex items-center">
              <FormControlLabel
                checked={!!setting?.isEnable}
                label=""
                className="m-0 w-[40px] h-[24px]"
                onClick={e => e.stopPropagation()}
                control={<Switch onChange={e => {
                  e.stopPropagation()
                  console.log('isEnable ', e.target.checked)
                  _.assign(setting, { isEnable: e.target.checked })
                }} />}
              />
              <span className="text-[14px] font-bold">{setting?.zoneName || ''}</span>
            </div>
            <img
              className="w-[24px] relative h-[24px] object-cover rotate-180"
              alt=""
              src="/iconarrow-down@2x.png"
            />
          </div>
          <div className="flex flex-col gap-2">
            <div className="self-stretch flex flex-col items-start justify-center gap-[4px] md:gap-[4px] sm:gap-[4px]">
              <div className="self-stretch flex flex-row items-start justify-start gap-[2px]">
                <div
                  className="relative font-semibold md:text-[12px] md:w-auto md:[align-self:unset]">Zone name:
                </div>
              </div>
              <TextField
                type={'string'}
                value={setting?.zoneName || ''}
                onChange={(e) => {
                  _.assign(setting, { zoneName: e.target.value })
                }}
                className="[border:none] bg-[transparent] self-stretch font-[Mulish] text-[14px] text-[#424242] md:pt-[9px] md:pb-[9px] md:box-border"
                color="primary"
                size="small"
                fullWidth={true}
                variant="outlined"
                sx={{ "& .MuiInputBase-root": { height: "37px" } }}
              />
            </div>
            <div className="self-stretch flex flex-col items-start justify-center gap-[4px] md:gap-[4px] sm:gap-[4px]">
              <div className="self-stretch flex flex-row items-start justify-start gap-[2px]">
                <div
                  className="relative font-semibold md:text-[12px] md:w-auto md:[align-self:unset]">Color:
                </div>
              </div>
              <div className="flex flex-wrap gap-2">
                {DELIVERY_ZONE_COLORS.map(color => (
                  <div key={color} className="relative w-6 h-6 rounded-full border"
                       style={{
                         backgroundColor: color,
                         borderColor: setting?.color === color ? "#077c7c" : "#d2d2d2"
                       }}
                       onClick={() => {
                         setting.color = color
                         updateColorPolygon(setting)
                       }}
                  >
                    {setting?.color === color &&
                      <img src="/checked-icon.svg" className="w-3 h-3 absolute top-0 -right-0.5" alt="" />}
                  </div>
                ))}
              </div>
            </div>
            <div className="self-stretch flex flex-col items-start justify-center gap-[4px] md:gap-[4px] sm:gap-[4px]">
              <div className="self-stretch flex flex-row items-start justify-start gap-[2px]">
                <div
                  className="relative font-semibold md:text-[12px] md:w-auto md:[align-self:unset]">Postal code:
                </div>
                <div className="flex-1 relative font-semibold text-[#fe081b] md:text-[12px] md:w-[43px]">
                  *
                </div>
              </div>
              <TextField
                type={'string'}
                value={setting?.postalCode || ''}
                onChange={(e) => {
                  _.assign(setting, { postalCode: e.target.value })
                  debounceDrawPolygon(setting, e.target.value)
                }}
                className="[border:none] bg-[transparent] self-stretch font-[Mulish] text-[14px] text-[#424242] md:pt-[9px] md:pb-[9px] md:box-border"
                color="primary"
                size="small"
                fullWidth={true}
                variant="outlined"
                sx={{ "& .MuiInputBase-root": { height: "37px" } }}
              />
            </div>
            <div className="self-stretch flex flex-col items-start justify-center gap-[4px] md:gap-[4px] sm:gap-[4px]">
              <div className="self-stretch flex flex-row items-start justify-start gap-[2px]">
                <div
                  className="relative font-semibold md:text-[12px] md:w-auto md:[align-self:unset]">Delivery cost:
                </div>
              </div>
              <TextField
                type={'number'}
                value={setting?.cost || 0}
                onChange={(e) => {
                  _.assign(setting, { cost: Number(e.target.value) })
                }}
                className="[border:none] bg-[transparent] self-stretch font-[Mulish] text-[14px] text-[#424242] md:pt-[9px] md:pb-[9px] md:box-border"
                color="primary"
                size="small"
                fullWidth={true}
                variant="outlined"
                sx={{ "& .MuiInputBase-root": { height: "37px" } }}
              />
            </div>
            <div className="self-stretch flex flex-col items-start justify-center gap-[4px] md:gap-[4px] sm:gap-[4px]">
              <div className="self-stretch flex flex-row items-start justify-start gap-[2px]">
                <div
                  className="relative font-semibold md:text-[12px] md:w-auto md:[align-self:unset]">Min order value:
                </div>
              </div>
              <TextField
                type={'number'}
                value={setting?.minOrderValue || 0}
                onChange={(e) => {
                  _.assign(setting, { minOrderValue: Number(e.target.value) })
                }}
                className="[border:none] bg-[transparent] self-stretch font-[Mulish] text-[14px] text-[#424242] md:pt-[9px] md:pb-[9px] md:box-border"
                color="primary"
                size="small"
                fullWidth={true}
                variant="outlined"
                sx={{ "& .MuiInputBase-root": { height: "37px" } }}
              />
            </div>
            <div className="self-stretch flex flex-col items-start justify-center gap-[4px] md:gap-[4px] sm:gap-[4px]">
              <div className="self-stretch flex flex-row items-start justify-start gap-[2px]">
                <div
                  className="relative font-semibold md:text-[12px] md:w-auto md:[align-self:unset]">Delivery free from:
                </div>
              </div>
              <TextField
                type={'number'}
                value={setting?.freeFrom || 0}
                onChange={(e) => {
                  _.assign(setting, { freeFrom: Number(e.target.value) })
                }}
                className="[border:none] bg-[transparent] self-stretch font-[Mulish] text-[14px] text-[#424242] md:pt-[9px] md:pb-[9px] md:box-border"
                color="primary"
                size="small"
                fullWidth={true}
                variant="outlined"
                sx={{ "& .MuiInputBase-root": { height: "37px" } }}
              />
            </div>
            <div
              ref={makeRipple}
              onClick={async () => {
                await deleteCurrentSetting(setting as any)
              }}
              className="self-stretch rounded-[2px] bg-[#f4dcdc] border-[#ff5252] border-[1px] border-solid overflow-hidden shrink-0 flex flex-row items-center justify-center p-[8px] text-center text-[#000]">
              <div
                className="relative font-semibold sm:text-[12px] mq768:text-[13px] mq600:text-[12px] h.414:text-[12px]">
                Delete
              </div>
            </div>
            {/*<div*/}
            {/*  className="self-stretch rounded-[2px] bg-[#00A21B] shrink-0 flex flex-row items-center justify-center p-[8px] text-center text-white">*/}
            {/*  <div*/}
            {/*    className="flex gap-1 items-center relative font-semibold sm:text-[12px] mq768:text-[13px] mq600:text-[12px] h.414:text-[12px]">*/}
            {/*    <img src="/save-icon@2x.png" className="w-5 h-5" alt="" />*/}
            {/*    Save*/}
            {/*  </div>*/}
            {/*</div>*/}
          </div>
        </div>
      }
    </div>
  );
}

export default ZoneFormItem;